import React from "react";

// Color mapping
const AVATAR_COLORS = [
    "#894BFF", "#605BFF", "#4B67FF", "#7983FF", "#0040DD",
    "#4BC1FF", "#00749F", "#5EAEFF", "#8594FF", "#7E34D7",
    "#1852FF", "#4656FF", "#A684FF"
];

const residue13 = (ch) => {
    const A = "A".charCodeAt(0);
    const c = ch.toUpperCase().charCodeAt(0);
    if (c < A || c > A + 25) return null;
    return (c - A) % 13;
};

const colorForInitials = (initials) => {
    const t = (initials || "").trim().toUpperCase();
    if (!t) return "#605BFF";

    if (t.length === 1) {
        const r = residue13(t[0]);
        return r == null ? "#605BFF" : AVATAR_COLORS[r];
    }

    const r1 = residue13(t[0]);
    const r2 = residue13(t[1]);
    if (r1 == null || r2 == null) return "#605BFF";

    const idx = (r1 + r2) % 13;
    return AVATAR_COLORS[idx];
};

const ProfileImage = ({ name = "", src = "", width = "56px", height = "56px", fontSize = "22px" }) => {
    const getInitials = (name) => {
        if (!name || name.trim() === "") {
            return "LT"; // Default initials
        }
        const nameParts = name.trim().split(" ");
        return nameParts
            .filter(part => part) // Filter out empty strings
            .map(part => part[0]?.toUpperCase() || "") // Use optional chaining for safety
            .join("")
            .slice(0, 2); // Limit to two characters
    };



    if (!name) {
        return (
            <img width={width} height={height} style={{borderRadius:"50%"}} src={"https://cdn.pixabay.com/photo/2017/02/23/13/05/avatar-2092113_960_720.png"}  />
        );
    }

    const initials = getInitials(name);
    const backgroundColor = colorForInitials(initials);

    return (
        <div
            style={{
                width: width,
                height: height,
                borderRadius: "50%",
                background: backgroundColor,
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                verticalAlign: "middle",
            }}
            title={name}
        >
            <span
                style={{
                    fontFamily: "Inter",
                    fontSize: fontSize,
                    fontWeight: 700,
                    lineHeight: "26.63px",
                    textAlign: "left",
                    textUnderlinePosition: "from-font",
                    textDecorationSkipInk: "none",
                    color: "#FFFFFF", // White text
                }}
            >
                {initials}
            </span>
        </div>
    );
};

export default ProfileImage;
